<template>
    <article class="film_article">
        <h3 class="film_article--title" v-html="film.title"></h3>

        <div class="grid-x">
            <figure class="film_article--poster cell shrink">
                <img :src="film.poster" :alt="film.title">
            </figure>
            <div class="film_article--info cell auto" v-html="film.information"></div>
            <div class="film_article--synopsis cell small-12" v-html="film.synopsis"></div>
        </div>
    </article>
</template>

<script>
export default {
    name: 'films-item',
    props: {
        film: Object
    },
    data () {
        return {
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/FilmsItem.vue